import Vue from "vue";
import QRious from "qrious";
import JsBarcode from "jsbarcode";
const { createCanvas } = require("canvas");

export default {
  printInformar(prosecution) {
    const office = prosecution.office;
    const company = prosecution.office.company;
    const procesamiento = prosecution.procesamiento;
    const venta = prosecution.venta;
    const customer = prosecution.venta.customer;
    const doctor = prosecution.venta.doctor;
    const procesamientoDetalle = prosecution.procesamientoDetalle;
    const history = prosecution.history;
    const imagen_url = prosecution.procesamiento?.nameFile ? prosecution.procesamiento.routeFile + prosecution.procesamiento?.nameFile : ""
    let imgCompleta = ""
    if(imagen_url.length > 0) {
      imgCompleta = `<img src="${process.env.VUE_APP_API_URL_BASE+'/'+imagen_url}" alt="logo_img"
      style="width: 450px; height: 300px; margin-top:30px;">`
    }
    console.log("==>>>>>>",imgCompleta)
    const color1 = "#048A00" // ? color green
    // const color1 = "#C40E0E"; // ? color red
    const color2 = "#00BAD3"; // ? color blue
    const color3 = "#9C9C9C"; // ? color gray

    const  calcularEdad = (fecha) => {
      var hoy = new Date();
      var cumpleanos = new Date(fecha);
      var edad = hoy.getFullYear() - cumpleanos.getFullYear();
      var m = hoy.getMonth() - cumpleanos.getMonth();
  
      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
          edad--;
      }
  
      return edad;
  }

    const edad = calcularEdad(customer.born_date)

    const formatDate = (date) => {
      let formatted_date =
        date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
      return formatted_date;
    };
    const day = formatDate(new Date());
    const hour = new Date().toLocaleTimeString();

    let registration_date = new Date(venta.registration_date);
    registration_date =
      formatDate(registration_date) +
      " " +
      registration_date.toLocaleTimeString();

    let procesamiento_create = new Date(procesamiento.created_at);
    procesamiento_create =
      formatDate(procesamiento_create) +
      " " +
      procesamiento_create.toLocaleTimeString();

    // ! codigo qr

    const link = window.location.origin + `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}`
    const qr = new QRious({
      value: link, // La URL o el texto
      size: 500,
      backgroundAlpha: 0, // 0 para fondo transparente
      foreground: "#000000", // Color del QR
      level: "H", // Puede ser L,M,Q y H (L es el de menor nivel, H el mayor)
    });

    setTimeout(function(){
    }, 800);

    const newCanvas = createCanvas();

    // ! codigo de barras
    const codigo = "S-00" + String(venta.id);
    const codigoBarra = JsBarcode(newCanvas, "Hello");

    let date = "";
    // !obtener la fecha del history
    history.forEach((item) => {
      // if (item.prosecution) {
      //   date =
      //     date +
      //     `<label>${formatDate(new Date(item.prosecution.date_process))}</label>`;
      // }
      date =
          date +  `<label>${item.prosecution ? formatDate(new Date(item.prosecution.date_process)) : "-"}</label>`;
    });

    // const qr = new QRious();
    // qr.background = 'green';
    // qr.backgroundAlpha = 0.8;
    // qr.foreground = 'blue';
    // qr.foregroundAlpha = 0.8;
    // qr.level = 'H';
    // qr.padding = 25;
    // qr.size = 500;
    // qr.value = 'https://github.com/neocotic/qrious';
    // console.log("=====>>>>>", qr);

    // var qr = new QRious({
    //   element: '<canvas id="qr"></canvas>',
    //   value: 'https://github.com/neocotic/qrious'
    // });

    // console.log(qr);

    let content = "";
    let count = 1;
    procesamientoDetalle.map((item) => {
      if (!item.active) return;
      let className = "";
      if (count % 2 == 0) {
        className = "underlined-row";
      }

      const rank = item.rank || "";
      let newRank = rank.replaceAll("<p>", "<label>");
      newRank = newRank.replaceAll("</p>", "</label>");

      // ! cuando es cabecera
      // if (item.service_detail_id == null) {
      if (item.index == -1) {
        // ! cuando es compuesto
        if (item.iscompound == "on ") {
          content =
            content +
            `<tr class="tr-analisis ${className}">
            <td class="name-analisis" style="padding:5px; 0px 5px 10px;">${item.name}</td>
        </tr>`;
        } else {
          content =
            content +
            `<tr class="tr-analisis ${className}">
                <td class="name-analisis" style="padding:5px; 0px 5px 10px;">${
                  item.name
                }</td>
                <td class="table-answer-tr">${
                  item.result ? item.result : ""
                }</td>
                <td>
                  <div style="display:flex; width:100%; justify-content: space-around;">
                      <label>${item.history01 ? item.history01 : ""}</label>
                      <label>${item.history02 ? item.history02 : ""}</label>
                  </div>
                </td>
                <td class="table-answer-tr" style="display: flex; flex-direction: column; padding:3px 0 3px 5px;">
                    ${newRank}
                </td>
                
        </tr>`;
        }
      } else {
        // ! cuando es subanalisis
        content =
          content +
          `<tr class="tr-analisis ${className}">
                <td class="name-sub-analisis">${item.name}</td>
                <td class="table-answer-tr">${
                  item.result ? item.result : ""
                }</td>
                <td>
                  <div style="display:flex; width:100%; justify-content: space-around;">
                    <label>${item.history01 ? item.history01 : ""}</label>
                    <label>${item.history02 ? item.history02 : ""}</label>
                  </div>
                </td>
                <td class="table-answer-tr" style="display: flex; flex-direction: column; padding:3px 0 3px 5px;">
                    ${newRank}
                </td>
                
        </tr>`;
      }

      count++;
    });
  
    // <td class="table-answer-tr">${
    //   item?.unit ? item.unit.name : ""
    // }</td>

    // @font-face {
    //     font-family: 'Montserrat';
    //     src: url({{ storage_path('fonts/Montserrat/static/Montserrat-Regular.ttf')}}) format("truetype");
    // }
    // @media print {
    //     body {-webkit-print-color-adjust: exact;}
    //     }

    // font-family: Verdana, Geneva, Tahoma, sans-serif;

    // @import url('https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,400;0,700;1,400;1,700&display=swap');
    // @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');

    const style = `<style type="text/css" media="screen, print">
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    .thin {
        /* Montserrat Thin = 100 */
        font-weight: 100;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    .extralight {
        /* Montserrat Extra Light = 200 */
        font-weight: 200;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .light {
        /* Montserrat Light = 300 */
        font-weight: 300;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .regular {
        /* Montserrat Regular = 400 */
        font-weight: 400;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .medium {
        /* Montserrat Medium = 500 */
        font-weight: 500;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .semibold {
        /* Montserrat Semi-bold = 600 */
        font-weight: 600;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .bold {
        /* Montserrat Bold = 700 */
        font-weight: 700;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .extrabold {
        /* Montserrat Extra Bold = 800 */
        font-weight: 800;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .black {
        /* Montserrat Black = 900 */
        font-weight: 900;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }

    body {
            margin: 0cm 0cm;
            font-size: 12px;
            font-family: 'Open Sans', sans-serif;
        }

        .cabecera {
          display: flex;
          height: 8%;
          width: 100%;
      }

      .nameSucursal {
          width: 50%;
          text-align: end;
          color: #179DC8;
          font-weight: 600;
          padding: 3px 5px 3px 0;
      }

      .nameDireccion {
          width: 50%;
          text-align: start;
          font-weight: 100;
      }

      .line {
          margin: 2px 0;
          display: flex;
          width: 100%;
          height: 1px;
      }

      .nameInfo {
        color: black;
        font-weight: bold;
      }

      .answerInfo {
          color: #616161;
          font-weight: 500;
          padding-Left:4px;
      }

      .table-cabecera-name {
          background-color: #ECECEC;
          padding: 5px 0;
          font-weight: 500;
      }

      .tr-analisis {
          color: #7B7B7B;
      }

      .tr-sub-analisis {
          color: #7B7B7B;
      }

      .underlined-row {
          background-color: #F8F8F8;
      }

      .custom-section {
        padding: 20px 50px 0px 50px;
    }

      .name-analisis {
          color: #393939;
          font-weight: 600;
          padding: 0 0 0 10px;
      }

      .name-sub-analisis {
          padding: 3px 0 3px 20px;
      }

      .table-answer-tr {
          padding: 0 0 0 5px;
      }
      footer {
        position: fixed;
        bottom: 0;
        width: 100%;
      }
      header{
        position: fixed;
        top: 0;
        width: 100%;
      }
      .content-body-aux{
        position: fixed;
        top: 22%;
        width: 100%;
        height: 45rem;
      }
      .content-body {
        margin-top: 28%;
        margin-left: 0;
        margin-right: 0;
        // margin-bottom: 150px;
        background-color: #C1FFBF;
      }

      footer {
        font-size: 9px;
        color: #f00;
        text-align: center;
      }

  </style>`;

    const styleAux = `
  <style type="text/css" media="screen, print">

  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    .thin {
        /* Montserrat Thin = 100 */
        font-weight: 100;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    .extralight {
        /* Montserrat Extra Light = 200 */
        font-weight: 200;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .light {
        /* Montserrat Light = 300 */
        font-weight: 300;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .regular {
        /* Montserrat Regular = 400 */
        font-weight: 400;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .medium {
        /* Montserrat Medium = 500 */
        font-weight: 500;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .semibold {
        /* Montserrat Semi-bold = 600 */
        font-weight: 600;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .bold {
        /* Montserrat Bold = 700 */
        font-weight: 700;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .extrabold {
        /* Montserrat Extra Bold = 800 */
        font-weight: 800;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .black {
        /* Montserrat Black = 900 */
        font-weight: 900;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }

    body {
        margin: 0cm 0cm;
        font-size: 12px;
        font-family: 'Open Sans', sans-serif;
    }

  /* Styles go here */

.page-header, .page-header-space {
  height: 250px;
}

.page-footer, .page-footer-space {
  height: 90px;
}

.cabecera {
    display: flex;
    height: 80px;
    width: 100%;
}

.nameInfo {
    color: black;
    font-weight: bold;
}

.answerInfo {
      color: #616161;
      font-weight: 500;
      padding-Left:4px;
}

.table-cabecera-name {
    background-color: #ECECEC;
    padding: 5px 0;
    font-weight: 500;
}

.page-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid black; /* for demo */
}

.page-header {
  position: fixed;
  width: 100%;
}

.tr-analisis {
    color: #7B7B7B;
}

.tr-sub-analisis {
    color: #7B7B7B;
}

.underlined-row {
    background-color: #F8F8F8;
}

.custom-section {
  padding: 20px 50px 0px 50px;
}

.name-analisis {
    color: #393939;
    font-weight: 600;
    padding: 0 0 0 10px;
}

.name-sub-analisis {
    padding: 3px 0 3px 20px;
}

.table-answer-tr {
    padding: 0 0 0 5px;
}

.page {
  page-break-after: always;
}

@page {
  margin: 20mm
}

footer {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

@media print {
   thead {display: table-header-group;} 
   tfoot {display: table-footer-group;}
   
   button {display: none;}
   
   body {margin: 0;}
} </style>`;

    const section01 = `
    <section style="padding: 20px 50px 0px 50px;">
            <div class="cabecera" >
                <!-- logos -->
                <div style="display:flex; width: 40%;">
                    <div style="display:flex; width: 70%; height: 75%;">
                        <img src="img/${company.img_url}" alt="logo"
                        style="width: 100%; height: 100%;">
                    </div>
                </div>
                <!-- info sucursales -->
            <div style="display:flex; width: 60%; flex-direction: column; align-items: end; font-size: 11.5px;">
                <div style="display:flex; padding-top: 5px; font-weight: 500;">
                    <label style="color: ${color3};">www.</label>
                    <label style="color: ${color1}; font-weight: 700;">tomolab</label>
                    <label style="color: ${color3};">.com</label>
                </div>
                <div style="display:flex;  padding-top: 5px; font-weight: 500;">
                    <label style="color: ${color3};">Central Telefonica :</label>
                    <label style="color: ${color1}; font-weight: 700;">(004) - 909090</label>
                </div>
                <div style="display:flex;  padding-top: 5px; font-weight: 500;">
                    <label style="color: ${color3};">Whatsapp :</label>
                    <label style="color: ${color1}; font-weight: 700;">998 383 333</label>
                </div>
                <div style="display:flex;  padding-top: 5px; font-weight: 500;">
                    <label style="color: ${color3};">Sede Principal :</label>
                    <label style="color: ${color1}; font-weight: 700;">Jr. Bolognesi 334</label>
                </div>
            </div>
            </div>
        </section>`;

    const section01Aux = `
    <section style="padding: 20px 50px 0px 50px;">
            <div class="cabecera" >
                <!-- logos -->
                <div style="display:flex; width: 40%;">
                    <div style="display:flex; width: 65%; height: 72%;">
                        <img src="img/${company.img_url}" alt="logo"
                        style="width: 100%; height: 100%;">
                    </div>
                </div>
                <!-- info sucursales -->
              <div style="display:flex; width: 60%; flex-direction: column; align-items: end; font-size: 11.5px;">
                  <div style="display:flex; padding-top: 5px; font-weight: 500;">
                      <label style="color: ${color3};">www.</label>
                      <label style="color: ${color1}; font-weight: 700;">sagradocorazon</label>
                      <label style="color: ${color3};">.com</label>
                  </div>
                  <div style="display:flex;  padding-top: 5px; font-weight: 500;">
                      <label style="color: ${color3};">Central Telefonica :</label>
                      <label style="color: ${color1}; font-weight: 700;">(004) - 909090</label>
                  </div>
                  <div style="display:flex;  padding-top: 5px; font-weight: 500;">
                      <label style="color: ${color3};">Whatsapp :</label>
                      <label style="color: ${color1}; font-weight: 700;">974 134 860</label>
                  </div>
                  <div style="display:flex;  padding-top: 5px; font-weight: 500;">
                      <label style="color: ${color3};">Sede :</label>
                      <label style="color: ${color1}; font-weight: 700;">Calle Los Zafiros 330, Urb. Santa Inés</label>
                  </div>
              </div>
            </div>
        </section>`;

    const section02 = `
    <section style="padding: 14px 50px 0px 50px;">
        <div style="display: flex; width: 100%;">
            <div style="display: flex; flex-direction: column; width: 100%; font-size: 12px; font-weight: bold;">
                <div style="display: flex; align-items: center;">
                    <div style=" display: flex; width: 60%;">
                      <label for="" class="nameInfo">PACIENTE : </label>
                      <label for="" class="answerInfo">${
                        customer.fullname ? customer.fullname : ""
                      }</label>
                    </div>
                </div>
                <div style="display: flex; align-items: center; padding-top:2px;">
                    <label for="" class="nameInfo">MEDICO : </label>
                    <label for="" class="answerInfo">${
                      doctor ? doctor.fullname : ""
                    }</label>
                </div>
                <div style="display: flex; align-items: center; padding-top:2px;">
                    <label for="" class="nameInfo">INSTITUCION : </label>
                    <label for="" class="answerInfo">----</label>
                </div>
                <div style="display: flex; margin-top:13px; align-items: center;">
                    <div style=" display: flex; width: 65%; align-items: center;">
                      <label for="" class="nameInfo">DNI : </label>
                      <label for="" class="answerInfo">${
                        customer.document ? customer.document : ""
                      }</label>
                    </div>
                    <div style=" display: flex; width: 35%; align-items: center;  font-size: 10.5px;">
                        <label for="" class="nameInfo" style="width:36%;">FECHA REGISTRO: </label>
                        <label for="" class="answerInfo">${registration_date}</label>
                    </div>
                </div>

                <div style="display: flex; padding-top:2px;">
                    <div style=" display: flex; width: 28%; align-items: center;">
                        <label for="" class="nameInfo">FECHA DE NAC : </label>
                        <label for="" class="answerInfo">${
                          customer.born_date ? customer.born_date : ""
                        }</label>
                    </div>
                    <div style=" display: flex; width: 37%; align-items: center;">
                        <label for="" class="nameInfo">EDAD : </label>
                        <label for="" class="answerInfo">${edad}</label>
                    </div>
                    <div style=" display: flex; width: 35%; align-items: center; font-size: 10.5px;">
                        <label for="" class="nameInfo" style="width:35%; ">TOMA MUESTRA: </label>
                        <label for="" class="answerInfo">${procesamiento_create}</label>
                    </div>
                </div>

                <div style="display: flex; padding-top:2px;">
                    <div style=" display: flex; width: 28%; align-items: center;">
                        <label for="" class="nameInfo">TELEFONO : </label>
                        <label for="" class="answerInfo">${
                          customer.phone ? customer.phone : ""
                        }</label>
                    </div>
                    <div style=" display: flex; width: 37%; align-items: center;">
                        <label for="" class="nameInfo">DIRECCION : </label>
                        <label for="" class="answerInfo">${
                          customer.address ? customer.address : ""
                        }</label>
                    </div>
                    <div style="display: flex; width: 35%; align-items: center;  font-size: 10.5px;">
                        <label for="" class="nameInfo" style="width:40%;">FECHA IMPRESION: </label>
                        <label for="" class="answerInfo">${day +
                          " " +
                          hour}</label>
                    </div>
                </div>

            </div>
        </div>
        <div style="position:absolute; top:135px; right:50px;">
          <div style="display: flex; align-items: center; flex-direction: column; ">
            <div style="position:relative;">
              <svg id="barcode" style="display:flex; width: 20%!important; height: 8%!important;"></svg>
              <div style="position:absolute; bottom:-5px; left:40%; ">
                <label style="display:flex; ">${codigo}</label>
              </div>
            </div>
          </div>
        </div>
    </section>`;
    const section03 = `
    <section style="padding: 0px 45px 5px 45px; ">
            <table style="width: 100%; font-size:11px;">
                <thead>
                    <tr>
                    <th class="table-cabecera-name" style="width:30%; border-top-left-radius: 9px; padding-left: 15px; text-align: start;">ANALISIS</th>
                    <th class="table-cabecera-name" style="width:15%; padding-left: 5px; text-align: start;">RESULTADOS</th>
                    <th class="table-cabecera-name" style="width:25%; padding-left: 15px; text-align: start;">
                        <div style="display:flex; flex-direction: column; justify-content: center; align-items:center;">
                            <label>HISTORICOS</label>    
                            <div style="display:flex; width:100%; justify-content: space-around;">
                                ${date}  
                            </div>
                        </div>
                    </th>
                    <th class="table-cabecera-name" style="width:30%; padding-left: 15px; text-align: start;">RANGO PREFERENCIAL</th>
                    </tr>
                </thead>
                <tbody style="font-size:10px;">
                    ${content}
                </tbody>
            </table>
            <div style="display:flex; justify-content: center;">
            ${imgCompleta}
            </div>
        </section>
    `;

{/* <tr class="tr-analisis">
                        <td class="name-analisis">DEPURACION DE CREATININA</td>
                    </tr>
                    <tr class="tr-sub-analisis underlined-row">
                        <td class="name-sub-analisis">CREATININA EN SUERO</td>
                        <td class="table-answer-tr">1.14</td>
                        <td class="table-answer-tr">mg/dL</td>
                        <td class="table-answer-tr" style="display: flex; flex-direction: column;">
                            <label for="">HOMBRES: 0.6 - 1.3</label>
                            <label for="">MUJERES: 0.5 - 1.1</label>
                        </td>
                    </tr>
                    <tr class="tr-sub-analisis">
                        <td class="name-sub-analisis">CREATININA EN SUERO</td>
                        <td class="table-answer-tr">1.14</td>
                        <td class="table-answer-tr">mg/dL</td>
                        <td class="table-answer-tr" style="display: flex; flex-direction: column;">
                            <label for="">HOMBRES: 0.6 - 1.3</label>
                            <label for="">MUJERES: 0.5 - 1.1</label>
                        </td>
                    </tr> */
    }

    const footer = `
    <footer >
      <div style="display: flex; width:100%; justify-content: space-between; padding-bottom:10px;">
        <div style="display:flex; width:33%;"></div>
        <div style="display:flex;flex-direction: column;width:33%; justify-content: center; align-items: center;">
          <label style="font-size: 11px; font-weight: bold;">QR Evite Falsificaciones</label>
          <div style="display:flex; width:80px; height:75px;">
            <img src="${qr.image.src}" style="width: 100%; height: 100%;"></img>
          </div>
        </div>
        <div style="display:flex; width:34%; justify-content:center;">
          <div style="text-align: end; padding-right: 8%; padding-bottom: 3%;">
              <img src="img/firma_hector_armas.png" alt="firma"
                  style="width: 110px; height: 70px;">
          </div>
        </div>
      </div>
    </footer>`;

    // <footer style="position: relative; width: 100%; height: 10%;">
    //     <div style="position: absolute; right: 80px; bottom: 20px;">
    //         <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Firma_de_Juan_Jos%C3%A9_Pradera.svg/1200px-Firma_de_Juan_Jos%C3%A9_Pradera.svg.png" alt=""
    //             style="width: 50px; height: 50px;">
    //     </div>
    // </footer>

    {
      /* <div class="line" style="background-color: ${color2};"></div> */
    }

    const body = `
    <div style="width: 100%; height: 100%; font-size: 13.5px;">
      <!-- cabecera superior -->
      <header>
        ${section01}
        <div style="display: flex; font-weight: 600; color: ${color1}; justify-content: center; font-size:18.5px;">
            <label for="" >
                INFORME DE RESULTADOS DE ANÁLISIS
            </label>
        </div>
        <!-- info de paciente -->
        ${section02}
      </header>
      <div class="content-body">
        <!-- analisis  -->
        ${section03}
      </div>
      ${footer}
    </div>
    `;

    // return style + body;
    return (
      `<head>
    <script src="https://unpkg.com/qrious@4.0.2/dist/qrious.js"></script>
    <script src="js/JsBarcode.all.min.js"></script>
    </head>` +
      styleAux +
      `
    <body>

  <div class="page-header">
    <header >
        ${section01}
        <div style="display: flex; font-weight: 600; color: ${color1}; justify-content: center; font-size:18.5px; padding-top:13px;">
            <label for="" >
                INFORME DE RESULTADOS DE ANÁLISIS
            </label>
        </div>
        <!-- info de paciente -->
        ${section02}
    </header>
  </div>

  <table style=" width:100%;">

    <thead>
      <tr>
        <td>
          <div class="page-header-space"></div>
        </td>
      </tr>
    </thead>

    <tbody >
      <tr >
        <td >
          <div class="page" >
            <div >
                <!-- analisis  -->
                ${section03}
            </div>
          </div>
        </td>
      </tr>
    </tbody>

    <tfoot>
      <tr>
        <td>
          <div class="page-footer-space">
            ${footer}
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</body>
<script>
JsBarcode("#barcode", "${codigo}", {
  format: "CODE39",
  lineColor: "#000",
  width: 1.2,
  height: 30,
  displayValue: false
});
</script>
    `
    );
  },
};
